import { render } from "./LoggedUser.vue?vue&type=template&id=fcdccc7e&scoped=true"
import script from "./LoggedUser.vue?vue&type=script&lang=js"
export * from "./LoggedUser.vue?vue&type=script&lang=js"

import "./LoggedUser.vue?vue&type=style&index=0&id=fcdccc7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcdccc7e"]])

export default __exports__